<template>
  <transition appear name="fade">
    <div v-if="isMobileOrTablet">
      <div class="pb-5">
        <appHeader></appHeader>
        <div class="container-fluid p-3 product-page pt-5 mt-4">
          <div class="row">
            <b-form
              class="col-12 col-md-9 col-lg-7 px-3 pr-md-2 travel-events row"
            >
              <h3 class="w-100 no-bottom-border">
                Want to take a trip or go to a concert?
              </h3>
              <h5 class="w-100">
                You can use your points for a travel package of your choice
              </h5>
              <div class="alert alert-info p-2" style="background-color: lavender;">
              <font-awesome-icon class="mr-2" :icon="['fas', 'bell']" />
              <strong></strong>We will be sunsetting</strong> our Travel Concierge  <strong>service at the end of this year.</strong> 
                The last day to take advantage of the Travel Concierge offering is <strong>December 31, 2024.</strong>
              </div>
              <div class="alert alert-info bg-warning-50 p-2">
                <font-awesome-icon class="mr-2" icon="user-clock" />
                <strong
                  >Hours of operation 11AM to 6PM eastern time Monday -
                  Friday.</strong>
                <br>
                <font-awesome-icon class="mr-2" icon="wrench" />
                <strong>We are unable to support same-day booking requests and ask that you provide our travel team with event/booking dates at least three business days in advance. Thank you!</strong>
              </div>
              <p>
                Although our travel coordinator usually gets back to you within
                a few hours of submission during business hours, there may be
                times when volume is high, so please allow a full day for our
                coordinator to get back to you.
              </p>
              <h6 class="my-2">
                Please fill out the form and one of our travel experts will call
                you to book your package.
              </h6>
              <hr />
              <div class="row col-12">
                <div class="col-12 col-sm-6 mb-3 pl-sm-0">
                  <label>First name</label>
                  <b-form-input
                    v-model="firstName"
                    class="form-control"
                    required
                    type="text"
                  >
                  </b-form-input>
                  <div class="invalid-feedback">A valid name is required.</div>
                </div>
                <div class="col-12 col-sm-6 mb-3 pl-sm-0">
                  <label>Last name</label>
                  <b-form-input
                    v-model="lastName"
                    class="form-control"
                    required
                    type="text"
                  >
                  </b-form-input>
                </div>
              </div>
              <div class="row col-12">
                <div class="col-12 col-sm-6 mb-3 pl-sm-0 pb-2">
                  <label>Daytime Phone</label>
                  <b-form-input
                    v-model="daytimePhone"
                    class="form-control"
                    placeholder="ie. color, model, size"
                    required
                    type="tel"
                  >
                  </b-form-input>
                </div>
                <div class="col-12 col-sm-6 mb-3 pl-sm-0">
                  <label>Mobile phone</label>
                  <b-form-input
                    v-model="mobilePhone"
                    class="form-control"
                    type="tel"
                  >
                  </b-form-input>
                </div>
              </div>
              <div class="w-100">
                <b-tabs content-class="pt-3">
                  <!-- Flights -->
                  <b-tab v-show="!submitted" active>
                    <template v-slot:title>
                      <font-awesome-icon class="" icon="plane" />
                      Flights
                    </template>
                    <div class="p-3 row">
                      <div class="col-12 col-sm-6">
                        <div class="date-picker rounded p-2">
                          <font-awesome-icon
                            class="mr-2"
                            icon="map-marker-alt"
                          />
                          From
                          <b-form-input
                            v-model="flightFrom"
                            class="form-control"
                            placeholder="Departure city"
                            required
                            size="lg"
                            type="text"
                          >
                          </b-form-input>
                        </div>
                        <b-input-group class="my-2 mr-1 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon
                                class=""
                                icon="plane-departure"
                              />
                            </div>
                          </b-input-group-prepend>
                          <b-input
                            placeholder="Preferred airport"
                            type="text"
                            v-model="airportDeparture"
                          ></b-input>
                        </b-input-group>
                      </div>
                      <div class="col-12 col-sm-6">
                        <div class="date-picker rounded p-2">
                          <font-awesome-icon
                            class="mr-2"
                            icon="map-marker-alt"
                          />
                          To
                          <b-form-input
                            v-model="flightTo"
                            class="form-control"
                            placeholder="Arrival city"
                            required
                            size="lg"
                            type="text"
                          >
                          </b-form-input>
                        </div>
                        <b-input-group class="my-2 mr-1 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon
                                class=""
                                icon="plane-arrival"
                              />
                            </div>
                          </b-input-group-prepend>
                          <b-input
                            placeholder="Preferred airport"
                            type="text"
                            v-model="airportReturn"
                          ></b-input>
                        </b-input-group>
                      </div>
                      <div class="row date-picker rounded m-2 w-100">
                        <div class="col-12 col-sm-6 first">
                          <b-form-datepicker
                            id="departure-date"
                            button-content="a"
                            local="en"
                            placeholder="+ Add departure date"
                            required
                            size="lg"
                            v-model="departureDate"
                          ></b-form-datepicker>
                        </div>
                        <div class="col-12 col-sm-6">
                          <b-form-datepicker
                            id="return-date"
                            button-content="a"
                            local="en"
                            placeholder="+ Add return date"
                            size="lg"
                            v-model="arrivalDate"
                          ></b-form-datepicker>
                        </div>
                      </div>
                      <div class="col-12 text-right">
                        <button
                          class="btn btn-primary btn-lg btn-sm-block"
                          v-on:click="submitEventRequest('flight')"
                        >
                          Request flight
                        </button>
                      </div>
                    </div>
                  </b-tab>
                  <!-- Hotel -->
                  <b-tab v-show="!submitted" v-on:click="submitted = false">
                    <template v-slot:title>
                      <font-awesome-icon class="" icon="bed" />
                      Hotels
                    </template>
                    <div class="p-3 row">
                      <div class="col-12 col-sm-6">
                        <div class="date-picker rounded p-2">
                          <font-awesome-icon
                            class="mr-2"
                            icon="map-marker-alt"
                          />
                          Location
                          <b-form-input
                            v-model="destination"
                            class="form-control"
                            placeholder="Where are you staying?"
                            required
                            size="lg"
                            type="text"
                          >
                          </b-form-input>
                        </div>
                      </div>
                      <div class="col-12 col-sm-3 rooms pl-0">
                        <b-input-group class="mb-2 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon class="mr-2" icon="hotel" />
                              Rooms
                            </div>
                          </b-input-group-prepend>
                          <b-input min="0" type="number" value="1"></b-input>
                        </b-input-group>
                        <b-input-group class="mb-2 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon class="mr-2" icon="user" />
                              Adults
                            </div>
                          </b-input-group-prepend>
                          <b-input min="0" type="number" value="1"></b-input>
                        </b-input-group>
                      </div>
                      <div class="col-12 col-sm-3 rooms pl-0">
                        <b-input-group class="mb-2 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon class="mr-2" icon="user" />
                              Children
                            </div>
                          </b-input-group-prepend>
                          <b-input min="0" type="number" value="1"></b-input>
                        </b-input-group>
                      </div>
                      <div class="row date-picker rounded m-2 w-100">
                        <div class="col-12 col-sm-6 first">
                          <b-form-datepicker
                            id="checkin-date"
                            button-content="a"
                            local="en"
                            placeholder="+Add check in date"
                            required
                            size="lg"
                          ></b-form-datepicker>
                        </div>
                        <div class="col-12 col-sm-6">
                          <b-form-datepicker
                            id="checkout-date"
                            button-content="a"
                            local="en"
                            placeholder="+ Add check out date"
                            required
                            size="lg"
                          ></b-form-datepicker>
                        </div>
                      </div>
                      <div class="col-12 text-right">
                        <button
                          class="btn btn-primary btn-lg btn-sm-block"
                          v-on:click="submitEventRequest('hotel')"
                        >
                          Request booking
                        </button>
                      </div>
                    </div>
                  </b-tab>
                  <!-- Events -->
                  <b-tab v-show="!submitted" v-on:click="submitted = false">
                    <template v-slot:title>
                      <font-awesome-icon class="" icon="ticket-alt" />
                      Events
                    </template>
                    <div class="p-3 row">
                      <div class="col-12 col-sm-6">
                        <b-input-group class="mb-2 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon
                                class=""
                                icon="football-ball"
                              />
                            </div>
                          </b-input-group-prepend>
                          <b-input
                            v-model="eventName"
                            class="form-control"
                            placeholder="Event you want to assist"
                            required
                            type="text"
                          >
                          </b-input>
                        </b-input-group>
                        <b-form-datepicker
                          id="event-date"
                          button-content="a"
                          class="date-picker mb-2"
                          local="en"
                          placeholder="Date of event"
                          required
                          size="md"
                          style="padding: 0.6em 1.2em"
                        ></b-form-datepicker>
                      </div>
                      <div class="col-12 col-sm-6">
                        <b-input-group class="mb-2 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">
                              <font-awesome-icon
                                class=""
                                icon="map-marker-alt"
                              />
                            </div>
                          </b-input-group-prepend>
                          <b-form-input
                            v-model="eventLocation"
                            class="form-control"
                            placeholder="Where is it happening?"
                            required
                            type="text"
                          >
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-2 float-left">
                          <b-input-group-prepend>
                            <div class="input-group-text">#Tickets</div>
                          </b-input-group-prepend>
                          <b-input min="0" type="number" value="1"></b-input>
                        </b-input-group>
                      </div>
                      <div class="col-12 text-right">
                        <button
                          class="btn btn-primary btn-lg btn-sm-block"
                          v-on:click="submitEventRequest('event')"
                        >
                          Request tickets
                        </button>
                      </div>
                    </div>
                  </b-tab>
                  <transition appear name="fade">
                    <div
                      v-show="success"
                      class="text-center bg-white w-100 submitted"
                    >
                      <p>
                        <strong>Your request has been sent. Thank you!</strong>
                      </p>
                      <div class="col-12 text-center pt-2">
                        <router-link
                          class="btn btn-primary"
                          :to="{ name: 'Shop' }"
                        >
                          <font-awesome-icon class="mr-1" icon="cart-plus" />
                          Continue shopping
                        </router-link>
                      </div>
                    </div>
                  </transition>
                </b-tabs>
              </div>
              <div class="alert alert-info bg-warning-50 p-2 text-strong mt-4">
                <h5 class="no-bottom-border p-2">Important</h5>
                <ul>
                  <li>
                    Trips do not qualify for any frequent flyer miles/programs.
                  </li>
                  <li>
                    Once you book your reservation, to change flights/hotel
                    room/car rental you must contact the airlines/hotel/rental
                    agency directly. charges may apply.
                  </li>
                </ul>
              </div>
            </b-form>
          </div>
        </div>
        <!-- /.container -->
        <appFooter></appFooter>
      </div>
      <navigationFooter></navigationFooter>
    </div>
    <div v-else class="mt-5">
      <appHeader></appHeader>
      <div class="container-fluid p-3 product-page">
        <div class="row">
          <div class="col-12 col-lg-3 col-sm-12 sidebar">
            <appProductSidebar></appProductSidebar>
          </div>
          <b-form
            class="col-12 col-md-9 col-lg-7 px-3 pr-md-2 travel-events row"
          >
            <h3 class="w-100 no-bottom-border">
              Want to take a trip or go to a concert?
            </h3>
            <h5 class="w-100">
              You can use your points for a travel package of your choice
            </h5>
            <div class="alert alert-info p-2" style="background-color: lavender;">
              <font-awesome-icon class="mr-2" :icon="['fas', 'bell']" />
              <strong></strong>We will be sunsetting</strong> our Travel Concierge  <strong>service at the end of this year.</strong> 
                The last day to take advantage of the Travel Concierge offering is <strong>December 31, 2024.</strong>
            </div>
            <div class="alert alert-info bg-warning-50 p-2">
              <font-awesome-icon class="mr-2" icon="user-clock" />
              <strong
                >Hours of operation 11AM to 6PM eastern time Monday -
                Friday.</strong>
              <br>
              <font-awesome-icon class="mr-2" icon="wrench" />
              <strong>We are unable to support same-day booking requests and ask that you provide our travel team with event/booking dates at least three business days in advance. Thank you!</strong>
            </div>
            <p>
              Although our travel coordinator usually gets back to you within a
              few hours of submission during business hours, there may be times
              when volume is high, so please allow a full day for our
              coordinator to get back to you.
            </p>
            <h6 class="my-2">
              Please fill out the form and one of our travel experts will call
              you to book your package.
            </h6>
            <hr />
            <div class="row col-12">
              <div class="col-12 col-sm-6 mb-3 pl-sm-0">
                <label>First name</label>
                <b-form-input
                  v-model="firstName"
                  class="form-control"
                  required
                  type="text"
                >
                </b-form-input>
                <div class="invalid-feedback">A valid name is required.</div>
              </div>
              <div class="col-12 col-sm-6 mb-3 pl-sm-0">
                <label>Last name</label>
                <b-form-input
                  v-model="lastName"
                  class="form-control"
                  required
                  type="text"
                >
                </b-form-input>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-12 col-sm-6 mb-3 pl-sm-0 pb-2">
                <label>Daytime Phone</label>
                <b-form-input
                  v-model="daytimePhone"
                  class="form-control"
                  placeholder="1234567890"
                  required
                  type="tel"
                >
                </b-form-input>
              </div>
              <div class="col-12 col-sm-6 mb-3 pl-sm-0">
                <label>Mobile phone</label>
                <b-form-input
                  v-model="mobilePhone"
                  class="form-control"
                  type="tel"
                >
                </b-form-input>
              </div>
            </div>
            <div class="w-100">
              <b-tabs content-class="pt-3">
                <!-- Flights -->
                <b-tab v-show="!submitted" active>
                  <template v-slot:title>
                    <font-awesome-icon class="" icon="plane" />
                    Flights
                  </template>
                  <div class="p-3 row">
                    <div class="col-12 col-sm-6">
                      <div class="date-picker rounded p-2">
                        <font-awesome-icon class="mr-2" icon="map-marker-alt" />
                        From
                        <b-form-input
                          v-model="flightFrom"
                          class="form-control"
                          placeholder="Departure city"
                          required
                          size="lg"
                          type="text"
                        >
                        </b-form-input>
                      </div>
                      <b-input-group class="my-2 mr-1 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon
                              class=""
                              icon="plane-departure"
                            />
                          </div>
                        </b-input-group-prepend>
                        <b-input
                          placeholder="Preferred airport"
                          type="text"
                          v-model="airportDeparture"
                        ></b-input>
                      </b-input-group>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="date-picker rounded p-2">
                        <font-awesome-icon class="mr-2" icon="map-marker-alt" />
                        To
                        <b-form-input
                          v-model="flightTo"
                          class="form-control"
                          placeholder="Arrival city"
                          required
                          size="lg"
                          type="text"
                        >
                        </b-form-input>
                      </div>
                      <b-input-group class="my-2 mr-1 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon class="" icon="plane-arrival" />
                          </div>
                        </b-input-group-prepend>
                        <b-input
                          placeholder="Preferred airport"
                          type="text"
                          v-model="airportReturn"
                        ></b-input>
                      </b-input-group>
                    </div>
                    <div class="row date-picker rounded m-2 w-100">
                      <div class="col-12 col-sm-6 first">
                        <b-form-datepicker
                          id="departure-date"
                          button-content="a"
                          local="en"
                          placeholder="+ Add departure date"
                          required
                          size="lg"
                          v-model="departureDate"
                        ></b-form-datepicker>
                      </div>
                      <div class="col-12 col-sm-6">
                        <b-form-datepicker
                          id="return-date"
                          button-content="a"
                          local="en"
                          placeholder="+ Add return date"
                          size="lg"
                          v-model="arrivalDate"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-12 text-right">
                      <button
                        class="btn btn-primary btn-lg btn-sm-block"
                        v-on:click="submitEventRequest('flight')"
                      >
                        Request flight
                      </button>
                    </div>
                  </div>
                </b-tab>
                <!-- Hotel -->
                <b-tab v-show="!submitted" v-on:click="submitted = false">
                  <template v-slot:title>
                    <font-awesome-icon class="" icon="bed" />
                    Hotels
                  </template>
                  <div class="p-3 row">
                    <div class="col-12 col-sm-6">
                      <div class="date-picker rounded p-2">
                        <font-awesome-icon class="mr-2" icon="map-marker-alt" />
                        Location
                        <b-form-input
                          v-model="destination"
                          class="form-control"
                          placeholder="Where are you staying?"
                          required
                          size="lg"
                          type="text"
                        >
                        </b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-sm-3 rooms pl-0">
                      <b-input-group class="mb-2 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon class="mr-2" icon="hotel" />
                            Rooms
                          </div>
                        </b-input-group-prepend>
                        <b-input v-model="rooms" min=0 type="number"></b-input>
                      </b-input-group>
                      <b-input-group class="mb-2 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon class="mr-2" icon="user" />
                            Adults
                          </div>
                        </b-input-group-prepend>
                        <b-input v-model="adults" min=0 type="number"></b-input>
                      </b-input-group>
                    </div>
                    <div class="col-12 col-sm-3 rooms pl-0">
                      <b-input-group class="mb-2 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon class="mr-2" icon="user" />
                            Children
                          </div>
                        </b-input-group-prepend>
                        <b-input v-model="children" min=0 type="number"></b-input>
                      </b-input-group>
                    </div>
                    <div class="row date-picker rounded m-2 w-100">
                      <div class="col-12 col-sm-6 first">
                        <b-form-datepicker
                          id="checkin-date"
                          button-content="a"
                          local="en"
                          placeholder="+Add check in date"
                          required
                          size="lg"
                          v-model="fromDate"
                        ></b-form-datepicker>
                      </div>
                      <div class="col-12 col-sm-6">
                        <b-form-datepicker
                          id="checkout-date"
                          button-content="a"
                          local="en"
                          placeholder="+ Add check out date"
                          required
                          size="lg"
                          v-model="toDate"
                        ></b-form-datepicker>
                      </div>
                    </div>
                    <div class="col-12 text-right">
                      <button
                        class="btn btn-primary btn-lg btn-sm-block"
                        v-on:click="submitEventRequest('hotel')"
                      >
                        Request booking
                      </button>
                    </div>
                  </div>
                </b-tab>
                <!-- Events -->
                <b-tab v-show="!submitted" v-on:click="submitted = false">
                  <template v-slot:title>
                    <font-awesome-icon class="" icon="ticket-alt" />
                    Events
                  </template>
                  <div class="p-3 row">
                    <div class="col-12 col-sm-6">
                      <b-input-group class="mb-2 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon class="" icon="football-ball" />
                          </div>
                        </b-input-group-prepend>
                        <b-input
                          v-model="eventName"
                          class="form-control"
                          placeholder="Event you want to assist"
                          required
                          type="text"
                        >
                        </b-input>
                      </b-input-group>
                      <b-form-datepicker
                        id="event-date"
                        button-content="a"
                        class="date-picker mb-2"
                        local="en"
                        placeholder="Date of event"
                        required
                        size="md"
                        style="padding: 0.6em 1.2em"
                        v-model="eventDate"
                      ></b-form-datepicker>
                    </div>
                    <div class="col-12 col-sm-6">
                      <b-input-group class="mb-2 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">
                            <font-awesome-icon class="" icon="map-marker-alt" />
                          </div>
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="eventLocation"
                          class="form-control"
                          placeholder="Where is it happening?"
                          required
                          type="text"
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-2 float-left">
                        <b-input-group-prepend>
                          <div class="input-group-text">#Tickets</div>
                        </b-input-group-prepend>
                        <b-input v-model="numTickets" min="0" type="number" value="1"></b-input>
                      </b-input-group>
                    </div>
                    <div class="col-12 text-right">
                      <button
                        class="btn btn-primary btn-lg btn-sm-block"
                        v-on:click="submitEventRequest('event')"
                      >
                        Request tickets
                      </button>
                    </div>
                  </div>
                </b-tab>
                <transition appear name="fade">
                  <div
                    v-show="success"
                    class="text-center bg-white w-100 submitted text-success"
                  >
                    <p>
                      <strong>Your request has been sent. Thank you!</strong>
                    </p>
                    <div class="col-12 text-center pt-2">
                      <router-link
                        class="btn btn-primary"
                        :to="{ name: 'Shop' }"
                      >
                        <font-awesome-icon class="mr-1" icon="cart-plus" />
                        Continue shopping
                      </router-link>
                    </div>
                  </div>
                </transition>
                <p
                  v-show="!success && error != ''"
                  class="text-danger font-bold"
                >
                  {{ error }}
                </p>
              </b-tabs>
            </div>
            <div class="alert alert-info bg-warning-50 p-2 text-strong mt-4">
              <h5 class="no-bottom-border p-2">Important</h5>
              <ul>
                <li>
                  Trips do not qualify for any frequent flyer miles/programs.
                </li>
                <li>
                  Once you book your reservation, to change flights/hotel
                  room/car rental you must contact the airlines/hotel/rental
                  agency directly. charges may apply.
                </li>
              </ul>
            </div>
          </b-form>
        </div>
      </div>
      <!-- /.container -->
      <appFooter></appFooter>
    </div>
  </transition>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ProductSidebar from "./ProductSidebar.vue";
import { isMobile, isTablet } from "mobile-device-detect";
import navigationFooter from "../../components/navigationFooter.vue";

export default {
  data() {
    return {
      // flights
      flightTo: "",
      flightFrom: "",
      firstName: "",
      lastName: "",
      daytimePhone: "",
      mobilePhone: "",
      departureDate: "",
      arrivalDate: "",
      airportDeparture: "",
      airportReturn: "",
      // hotel
      destination: "",
      adults: 1,
      children: 1,
      rooms: 1,
      fromDate: "",
      toDate: "",
      // events
      eventName: "",
      eventLocation: "",
      numTickets: 1,
      eventDate: "",


      submitted: false,
      success: false,
      error: "",
    };
  },
  computed: {
    isMobileOrTablet: function () {
      return isMobile || isTablet;
    },
  },
  methods: {
    async submitEventRequest(type) {
      this.error = "";
      this.success = false;

      let dispatch = "";
      let payload = {
        firstName: this.firstName,
        lastName: this.lastName,
        dayPhone: this.daytimePhone,
        mobilePhone: this.mobilePhone,
      };

      switch (type) {
        case "flight":
          dispatch = "Flight";
          payload.fromCity = this.flightFrom;
          payload.toCity = this.flightTo;
          payload.fromAirport = this.airportDeparture;
          payload.toAirport = this.airportReturn;
          payload.fromDate = this.departureDate;
          payload.toDate = this.arrivalDate;

          break;
        case "hotel":
          dispatch = "Hotel";
          payload.location = this.destination;
          payload.rooms = Number(this.rooms);
          payload.adults = Number(this.adults);
          payload.children = Number(this.children);
          payload.fromDate = this.fromDate;
          payload.toDate = this.toDate;
          break;
        case "event":
          dispatch = "Event";
          payload.eventName = this.eventName
          payload.location = this.eventLocation
          payload.tickets = Number(this.numTickets)
          payload.date = this.eventDate
          break;
        default:
          this.error = "Event type specififed not found!";
          conole.error(this.error);
      }

      try {
        const resp = await this.$store.dispatch(
          `concierge/request${dispatch}`,
          payload
        );

        if (resp.status != 200) {
          this.error = resp.data;
          console.error(resp);
          return;
        }

        this.success = true;
      } catch (e) {
        console.log(e);
        this.error = e;
      }
    },
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appProductSidebar: ProductSidebar,
    navigationFooter: navigationFooter,
  },
  created() {},
};
</script>

<style lang="scss">
.tab-content {
  border: 2px solid $gray-200;
  border-top: 0px;
}
.travel-events {
  .input-group-text {
    font-weight: 700 !important;
  }
  .date-picker {
    position: relative;
    height: auto;
    background-color: $gray-200;
    color: $gray-500;
    box-shadow: $input-box-shadow;
    font-weight: 700;
    & > div,
    label,
    button,
    .form-control {
      font-weight: 700;
      text-align: left;
      padding: 0.3em !important;
      box-shadow: none !important;
      margin-bottom: 0;
      color: $gray-700;
      height: inherit;
    }
  }
  .b-calendar-grid-body .btn {
    padding: 0px;
    width: 20px;
    height: 20px;
  }
  .first::after {
    border: 1px solid $gray-500;
    content: " ";
    width: 1px;
    margin: 15px 0;
    height: 50%;
    border-radius: 3px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
.input-group {
  box-shadow: $input-box-shadow !important;
  border-radius: $border-radius-sm;
  background-color: $gray-200;
  .input-group-prepend {
    & > div,
    .form-control {
      background-color: transparent !important;
      box-shadow: none !important;
    }
  }
}
.rooms {
  padding-left: 0px !important;
  .input-group-text {
    padding: 0.5rem 0.9rem;
    font-size: 0.9em;
  }
  svg {
    color: $gray-500;
  }
}
.submitted {
  padding: 70px 0;
}
.tabs {
  position: relative;
  .nav-link {
    color: white;
    text-decoration: none;
    background-color: #3782f3;
    margin-right: 1px;
    padding: 0.5rem 0.8rem;
  }
}
@media all and (max-width: 480px) {
  .rooms {
    .input-group {
      width: 100%;
      margin-right: 0em;
    }
  }
}
</style>
